<template>

    <div class="shops__block_filter">
        <div class="filter__block">
            <div class="filter__block_item">
                <div class="dropdown__block">
                    <button class="dropdown__block_trigger"
                            type="button"
                            @click="toggleDropdown"
                            aria-expanded="true">
                        Localitate
                        <svg class="svg"><use href="#svg__icon--arrow-down"></use></svg>
                    </button>

                    <Transition name="slide-up">
                        <div class="dropdown__block_menu">
                            <div class="dropdown__block_header">
                                <div class="h3">Localitate</div>
                            </div>
                            <div class="dropdown__block_body">
                                <ul class="dropdown__block_list">
                                    <li v-for="city in cities" :key="city.id">
                                        <a
                                            class="dropdown__block_menu_item"
                                            :class="{ selected: selectedCityId === city.id }"
                                            href="#"
                                            @click.stop.prevent="selectCity(city)"
                                        >
                                            {{ city.title[props.locale] }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="dropdown__block_footer">
                                <button class="dropdown__block_close" type="button" @click="closeDropdown">
                                    <svg class="svg "><use href="#svg__icon--close"></use></svg>
                                </button>
                            </div>
                        </div>
                    </Transition>
                </div>
            </div>
            <div class="filter__block_item" v-if="availableSectors.length">
                <div class="dropdown__block">
                    <button class="dropdown__block_trigger"
                            type="button"
                            @click="toggleDropdown"
                            aria-expanded="false">
                        Sector
                        <svg class="svg"><use href="#svg__icon--arrow-down"></use></svg>
                    </button>
                    <Transition name="slide-up">
                    <div class="dropdown__block_menu">
                        <div class="dropdown__block_header">
                            <div class="h3">Sector</div>
                        </div>
                        <div class="dropdown__block_body">
                            <ul class="dropdown__block_list">
                                <li v-for="sector in availableSectors" :key="sector.id">
                                    <button
                                        class="dropdown__block_menu_item"
                                        type="button"
                                        :class="{ selected: selectedSectorIds.includes(sector.id) }"
                                        @click.stop="toggleSector(sector.id)"
                                    >
                                        {{ sector.title[props.locale] }}
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div class="dropdown__block_footer">
                            <button class="dropdown__block_close" type="button" @click="closeDropdown">
                                <svg class="svg"><use href="#svg__icon--close"></use></svg>
                            </button>
                        </div>
                    </div>
                    </Transition>
                </div>
            </div>
            <div class="filter__block_item item--last">
                <div class="form__item_switch">
                    <input name="grill_cafe" type="checkbox" id="grill_cafe" v-model="grillCafeOnly">
                    <label for="grill_cafe">Doar Grill Cafe</label>
                </div>

                <ul class="tabs__nav" role="tablist">
                    <li class="tabs__nav_item" role="presentation">
                        <button
                            class="tabs__nav_link"
                            :class="{ active: activeTab === 'list' }"
                            type="button"
                            @click="switchTab('list')"
                        >
                            Listă
                        </button>
                    </li>
                    <li class="tabs__nav_item" role="presentation">
                        <button
                            class="tabs__nav_link"
                            :class="{ active: activeTab === 'map' }"
                            type="button"
                            @click="switchTab('map')"
                        >
                            Hartă
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="shops__block"
         :class="selectedShop ? 'full_info--open' : ''">
        <div class="shops__block_list"
             :class="{ 'show': activeTab === 'list' }">
            <div class="shops__list">
                <div
                    class="shops__list_item"
                    v-for="shop in filteredShops"
                    :key="shop.id"
                    :class="{ 'is-active': selectedShopId === shop.id }"
                    @click="selectShop(shop)">
                    <div class="shops__list_item_image">
                        <img v-if="shop.image && shop.image_formats[`${shop.image}`]?.original?.thumb"
                             :src="`/storage/shop/${shop.id}/${shop.image_formats[`${shop.image}`].original.thumb}`"
                             :alt="shop.title[props.locale]" />
                        <div v-else class="placeholder-image">No Image</div>
                    </div>

                    <div class="shops__list_item_short_info">
                        <div class="shops__list_item_title h4">{{ shop.title[props.locale] }}</div>
                        <div class="shops__list_item_address">{{ shop.address[props.locale] }}, {{ shop.city.title[props.locale] }}</div>
                        <div class="shops__list_item_address_working_hours">
                            <span :class="[ 'status', shopCurrentStatus(shop.working_hours).opened ? 'opened' : 'closed' ]">
                                {{ shopCurrentStatus(shop.working_hours).statusText }}
                            </span>
                            <span class="hours">
                                {{ scheduleTitle(shop) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <Transition name="slide-up">
            <div
                class="shops__list_item_full_info_wrapper"
                v-if="selectedShop"
                :data-shop-id="selectedShop.id">
                <div class="shops__list_item_full_info">
                    <div class="shops__list_item_image">
                        <img v-if="selectedShop.image && selectedShop?.image_formats[`${selectedShop.image}`]?.original?.card" :src="`/storage/shop/${selectedShop.id}/${selectedShop.image_formats[`${selectedShop.image}`].original.card}`" :alt="selectedShop.title[props.locale]" />
                        <div v-else class="placeholder-image">No Image</div>
                    </div>
                    <div class="shops__list_item_content">
                        <div class="shops__list_item_title h4">{{ selectedShop.title[props.locale] }}</div>
                        <div class="shops__list_item_description">{{ selectedShop.description[props.locale] }}</div>

                        <div class="shops__list_item_full_info_about">
                            <div class="shops__list_item_full_address">{{ selectedShop.address[props.locale] }}, {{ selectedShop.city.title[props.locale] }}</div>
                            <!-- WORKING HOURS DROPDOWN -->
                            <div class="shops__list_item_full_working_hours">

                                <div class="shops__list_item_address_working_hours">
                                    <span :class="[ 'status', shopCurrentStatus(selectedShop.working_hours).opened ? 'opened' : 'closed' ]">
                                      {{ shopCurrentStatus(selectedShop.working_hours).statusText }}
                                    </span>
                                    <div class="hours">
                                        <button
                                            type="button"
                                            class="dropdown__toggle"
                                            @click.stop="toggleSchedule"
                                            :aria-expanded="scheduleOpen.toString()"
                                        >
                                            {{ scheduleTitle(selectedShop) }}
                                            <span class="dropdown__arrow" :class="{ open: scheduleOpen }">
                                                    <svg fill="none" viewBox="0 0 24 24">
                                                        <path fill="CurrentColor" d="M19.54 10h1V8h-1v2m-7.88 5.52a1 1 0 1 0 1.75.96l-.87-.48zm-.12.85a1 1 0 0 0 1.85-.74l-.93.37zM5.46 8h-1v2h1V8m14.08 1V8c-1.15 0-2.2.61-3.07 1.32a16 16 0 0 0-2.42 2.57 30 30 0 0 0-2.38 3.6v.02h-.01v.01l.88.48.87.48.04-.07.58-.98c.4-.63.95-1.48 1.6-2.32s1.38-1.65 2.1-2.24q1.13-.88 1.8-.87zm-7.08 7 .93-.38-.04-.09a13 13 0 0 0-.5-1.07c-.34-.69-.85-1.6-1.5-2.53A12 12 0 0 0 8.93 9.3 5.7 5.7 0 0 0 5.46 8v2q1.13.01 2.25.89a10 10 0 0 1 2 2.18 19 19 0 0 1 1.8 3.24l.02.05v.01z"></path>
                                                    </svg>
                                                </span>
                                        </button>
                                    </div>
                                </div>

                                <Transition name="slide-down">
                                    <div v-if="scheduleOpen" class="dropdown__panel" role="list">
                                        <ul class="schedule__list">
                                            <li v-for="day in scheduleWithNames" :key="day.key" class="schedule__item" role="listitem">
                                                <div class="schedule__day">{{ day.name }}</div>
                                                <div class="schedule__hours">
                                                    <span v-if="day.enabled">{{ day.open }} – {{ day.close }}</span>
                                                    <span v-else>Închis</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </Transition>
                            </div>
                            <!-- /WORKING HOURS DROPDOWN -->
                            <div class="shops__list_item_full_phone">{{ selectedShop.phone }}</div>

                            <button class="button button--with-icon show__cart"
                                    type="button" @click="showShopOnMap">
                                Vezi pe hartă<svg class="svg"><use href="#svg__icon--arrow-right"></use></svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="shops__list_item_full_info_footer">
                    <button class="full__info_close" @click="closeFullInfo" type="button"></button>
                </div>
            </div>
            </Transition>
        </div>

        <div class="shops__block_map"
             :class="{ 'show': activeTab === 'map' }">
            <div class="shops__map">
                <GoogleMap
                    ref="mapRef"
                    style="width: 100%; height: 100%;"
                    :api-key="apiKey"
                    :map-id="mapId"
                    :center="center"
                    :zoom="7"
                >
                    <MarkerCluster>
                        <AdvancedMarker
                            v-for="shop in filteredShops"
                            :key="shop.id"
                            :options="{ position: shop.coordinates, content: getMarkerElement(shop.id) }"
                            @click="() => selectShop(shop)"
                            :ref="el => registerMarker(shop.id, el)"
                        />
                    </MarkerCluster>
                </GoogleMap>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, nextTick, onMounted } from "vue";
import { GoogleMap, AdvancedMarker, MarkerCluster } from "vue3-google-map";

/* ---------- CONFIG ---------- */
const apiKey = import.meta.env.VITE_REACT_APP_GOOGLE_MAPS_API_KEY;
const mapId = "e660c383595fcf9d1647879c";

/* ---------- REFS & STATE ---------- */
const mapRef = ref(null); // component ref
const pendingSelectedShop = ref(null);
const selectedShopId = ref(null);
const activeTab = ref('list')

/* schedule dropdown open */
const scheduleOpen = ref(false);

/* ---------- DATA ---------- */
const center = { lat: 47.0181, lng: 28.8345 };

const props = defineProps({
    cities: {
        type: Array,
        required: true,
    },
    shops: {
        type: Array,
        required: true,
    },
    locale: {
        type: String,
        required: true,
    },
    grill_cafe: {
        type: Boolean,
        required: false,
        default: () => false,
    }

});

const normalizeShop = (shop) => ({
    ...shop,
    coordinates: {
        lat: Number(shop.coordinates.lat),
        lng: Number(shop.coordinates.lng),
    },
});

const cities = props.cities;
const shops = props.shops.map(normalizeShop);

// console.log('cities:', cities);
// console.log('shops:', shops);

const selectedCityId = ref(null);
const selectedSectorIds = ref([]); // multi-select
const grillCafeOnly = ref(props.grill_cafe);

const selectedCity = computed(() =>
    cities.find(c => c.id === selectedCityId.value) ?? null
);

const availableSectors = computed(() =>
    selectedCity.value?.sectors ?? []
);

const selectCity = (city) => {
    selectedCityId.value = city.id;
    selectedSectorIds.value = [];
    closeOtherDropdowns();

    const comp = mapRef.value;
    if (comp && comp.ready) {
        const gmap = comp.map ?? null;
        if (gmap) {
            const cityShops = shops.filter(s => s.city.id === city.id);
            if (cityShops.length) {
                const bounds = new google.maps.LatLngBounds();
                cityShops.forEach(s => bounds.extend(s.coordinates));
                gmap.fitBounds(bounds);

                // если мало точек, не зумим слишком сильно
                if (cityShops.length <= 2) {
                    // через таймаут, чтобы fitBounds успел сработать
                    setTimeout(() => {
                        const currentZoom = gmap.getZoom();
                        const maxZoom = 14; // максимум приближения для мало точек
                        if (currentZoom > maxZoom) gmap.setZoom(maxZoom);
                    }, 100);
                }
            }
        }
    }
};

const switchTab = (tab) => {
    activeTab.value = tab
}

const toggleSector = (sectorId) => {
    if (selectedSectorIds.value.includes(sectorId)) {
        selectedSectorIds.value =
            selectedSectorIds.value.filter(id => id !== sectorId);
    } else {
        selectedSectorIds.value.push(sectorId);
    }
};


const closeOtherDropdowns = () => {
    const openDropdowns = document.querySelectorAll('.dropdown__block.open');
    openDropdowns.forEach((dd) => {
        dd.classList.remove('open');
        hideBackdrop();
    });
};

const toggleDropdown = (event) => {
    const button = event.currentTarget;
    const dropdown = button.closest('.dropdown__block');

    if (dropdown.classList.contains('open')) {
        dropdown.classList.remove('open');
        hideBackdrop();
    } else {
        closeOtherDropdowns();
        dropdown.classList.add('open');
        showBackdrop(button.parentElement);
    }
};

//click outside to close
document.addEventListener('click', (event) => {
    const openDropdowns = document.querySelectorAll('.dropdown__block.open');
    openDropdowns.forEach((dropdown) => {
        if (!dropdown.contains(event.target)) {
            dropdown.classList.remove('open');
            hideBackdrop();
        }
    });
});


const closeDropdown = (event) => {
    const button = event.currentTarget;
    const dropdown = button.closest('.dropdown__block');

    if (dropdown.classList.contains('open')) {
        dropdown.classList.remove('open');
        hideBackdrop();
    }
};

function showBackdrop(block) {
    if (!block) return null;

    let backdrop = block.querySelector('.dropdown-backdrop');
    if (backdrop) {
        if (!backdrop.classList.contains('fade')) backdrop.classList.add('fade');
        void backdrop.offsetHeight;
        backdrop.classList.add('show');
        return backdrop;
    }

    backdrop = document.createElement('div');
    backdrop.className = 'dropdown-backdrop fade';
    block.appendChild(backdrop);
    void backdrop.offsetHeight;
    backdrop.classList.add('show');

    backdrop.addEventListener('click', (e) => {
        e.stopPropagation();
        closeFullInfo();
    });

    return backdrop;
}

function hideBackdrop() {
    const backdrop = document.querySelector('.dropdown-backdrop');
    if (!backdrop) return;

    backdrop.classList.remove('show');

    if (backdrop && backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
}


const filteredShops = computed(() => {
    return shops.filter(shop => {
        // фильтр по городу
        if (selectedCityId.value && shop.city_id !== selectedCityId.value) {
            return false;
        }

        // ✅ ФИЛЬТР ПО СЕКТОРУ — С ПРОВЕРКОЙ
        if (selectedSectorIds.value.length) {
            if (!shop.sector || !shop.sector.id) {
                return false;
            }

            if (!selectedSectorIds.value.includes(shop.sector.id)) {
                return false;
            }
        }

        // фильтр Grill Cafe
        if (grillCafeOnly.value && !shop.grill_cafe) {
            return false;
        }

        return true;
    });
});


/* ---------- TIME HELPERS (unchanged) ---------- */
const timePatternValid = (s) => {
    if (!s || typeof s !== "string") return false;
    const m = s.match(/^([01]\d|2[0-3]):([0-5]\d)$/);
    return !!m;
};

const toMinutes = (time) => {
    const [h, m] = time.split(":").map(Number);
    return h * 60 + m;
};

const isCurrentInInterval = (open, close, current) => {
    if (!timePatternValid(open) || !timePatternValid(close) || !timePatternValid(current)) return false;
    const openM = toMinutes(open);
    const closeM = toMinutes(close);
    const curM = toMinutes(current);

    if (openM === closeM) return false;

    if (openM < closeM) {
        return curM >= openM && curM < closeM;
    } else {
        return curM >= openM || curM < closeM;
    }
};

const formatTime = (s) => {
    if (!timePatternValid(s)) return s || "";
    const [h, m] = s.split(":").map(Number);
    return `${h}:${String(m).padStart(2, "0")}`;
};

const dayNamesRO = ["Duminică", "Luni", "Marți", "Miercuri", "Joi", "Vineri", "Sâmbătă"];

/* Возвращает объект { opened, statusText, hoursText } */
const shopCurrentStatus = (working_hours) => {
    if (!Array.isArray(working_hours) || working_hours.length === 0) {
        return { opened: false, statusText: "", hoursText: "" };
    }

    const jsDay = new Date().getDay();
    const dayMap = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
    const todayKey = dayMap[jsDay];
    const today = working_hours.find((w) => w.key.toLowerCase() === todayKey);

    if (!today) return { opened: false, statusText: "", hoursText: "" };

    const open = today.open;
    const close = today.close;
    const hoursText = open && close ? `${formatTime(open)}–${formatTime(close)}` : "";

    if (!today.enabled) {
        return { opened: false, statusText: "închis", hoursText };
    }

    const now = new Date();
    const curStr = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;

    if (!timePatternValid(open) || !timePatternValid(close)) {
        return { opened: false, statusText: "închis", hoursText };
    }

    const openedNow = isCurrentInInterval(open, close, curStr);
    return { opened: openedNow, statusText: openedNow ? "Deschis" : "închis", hoursText };
};

/* ---------- SCHEDULE DROPDOWN HELPERS ---------- */

/* Возвращает массив дней с именами и часами для конкретного магазина */
const scheduleWithNames = computed(() => {
    if (!selectedShop.value) return [];
    const wh = selectedShop.value.working_hours || [];
    // order: monday..sunday but our dayNamesRO uses sunday index 0; we will map keys in order Mon..Sun
    const order = ["monday","tuesday","wednesday","thursday","friday","saturday","sunday"];
    return order.map((k) => {
        const item = wh.find(w => w.key.toLowerCase() === k);
        const idx = order.indexOf(k); // 0..6 (mon..sun)
        // map idx to JS day index: monday=1.. sunday=0 => jsIndex = (idx+1)%7
        const jsIndex = (idx + 1) % 7;
        return {
            key: k,
            name: dayNamesRO[jsIndex],
            enabled: item ? !!item.enabled : false,
            open: item && item.open ? formatTime(item.open) : null,
            close: item && item.close ? formatTime(item.close) : null
        };
    });
});

/* Получить сегодня (js day) schedule объект */
const getTodaySchedule = (shop) => {
    if (!shop) return null;
    const jsDay = new Date().getDay(); // 0..6 Sun..Sat
    const dayMap = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
    const todayKey = dayMap[jsDay];
    const today = (shop.working_hours || []).find(w => w.key.toLowerCase() === todayKey);
    return { today, jsDay };
};

/* Найти ближайшее следующее открытие (включая сегодня) */
const findNextOpening = (shop) => {
    if (!shop) return null;
    const dayMap = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
    const now = new Date();
    let curDay = now.getDay(); // 0..6
    const curMinutes = now.getHours()*60 + now.getMinutes();

    for (let i = 0; i < 7; i++) {
        const checkDay = (curDay + i) % 7;
        const key = dayMap[checkDay];
        const item = (shop.working_hours || []).find(w => w.key.toLowerCase() === key);
        if (!item) continue;
        if (!item.enabled) continue;

        const openM = toMinutes(item.open);
        const closeM = toMinutes(item.close);

        if (i === 0) {
            // today: if open time still in future -> return today.open
            if (curMinutes < openM) {
                return { jsDay: checkDay, open: item.open, close: item.close };
            }
            // if already open now, next opening is today (already open) — but we want closing; caller handles open case
            // otherwise if today's open already passed, skip
        } else {
            // future day
            return { jsDay: checkDay, open: item.open, close: item.close };
        }
    }
    return null;
};

/* Заголовок (Se închide la HH:MM / Se deschide la HH:MM or Se deschide Luni HH:MM) */
const scheduleTitle = (shop) => {
    // const shop = selectedShop.value;
    if (!shop) return "";

    const status = shopCurrentStatus(shop.working_hours);
    const todayInfo = getTodaySchedule(shop);
    const today = todayInfo?.today;

    if (status.opened) {
        // show today's close time if available
        const close = today && today.close ? formatTime(today.close) : null;
        return close ? `Se închide la ${close}` : "Se închide azi";
    } else {
        // find next opening (could be today later or future day)
        const next = findNextOpening(shop);
        if (!next) return "Se deschide curând";
        const openFormatted = next.open ? formatTime(next.open) : null;
        const dayName = dayNamesRO[next.jsDay];
        // if next.jsDay == today jsDay and open is later => "Se deschide la 09:00"
        const nowJsDay = new Date().getDay();
        if (next.jsDay === nowJsDay) {
            return openFormatted ? `Se deschide la ${openFormatted}` : "Se deschide azi";
        } else {
            return openFormatted ? `Se deschide ${dayName} la ${openFormatted}` : `Se deschide ${dayName}`;
        }
    }
};

/* ---------- MARKERS: DOM cache + active switching (unchanged) ---------- */
const NORMAL_PIN = "/build/images/pin.svg";
const ACTIVE_PIN = "/build/images/pin-active.svg";

const markerInstances = new Map();
const registerMarker = (shopId, markerComponent) => {
    if (!markerComponent) return;

    // Внутри компонента marker лежит тут
    const marker = markerComponent.marker;

    if (marker) {
        markerInstances.set(shopId, marker);
    }
};
const createMarkerElement = (shopId, isActive = false) => {
    const div = document.createElement("div");
    div.className = "custom-marker";

    const img = document.createElement("img");
    img.src = isActive ? ACTIVE_PIN : NORMAL_PIN;
    img.width = 56;
    img.height = 56;

    div.appendChild(img);

    div.addEventListener("click", (e) => {
        e.stopPropagation();
        const shop = shops.find(s => s.id === shopId);
        if (shop) selectShop(shop);
    });

    return div;
};

const getMarkerElement = (shopId) => {
    return createMarkerElement(shopId, shopId === selectedShopId.value);
};


/* ---------- selection / pending / apply on ready (unchanged) ---------- */
const selectedShop = computed(() => shops.find((s) => s.id === selectedShopId.value) ?? null);

const selectShop = async (shop) => {
  console.log("Selecting shop:", shop);
    selectedShopId.value = shop.id;

    // auto-open schedule dropdown for new selection
    scheduleOpen.value = false;

    showBackdrop(document.querySelector('.shops__block_list'));

    const comp = mapRef.value;
    if (!comp || !comp.ready) {
        pendingSelectedShop.value = shop;
    } else {
        const gmap = comp.map ?? null;
        if (gmap && typeof gmap.panTo === "function") {
            try {
                gmap.panTo(shop.coordinates);
                if (typeof gmap.setZoom === "function") gmap.setZoom(15);
            } catch (e) {
                console.warn("panTo/setZoom error:", e);
            }
        }
    }

    await nextTick();
    // scroll selected full-info into view if exists
    const el = document.querySelector(`.shops__list_item_full_info_wrapper[data-shop-id="${shop.id}"]`);
    if (el && typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
};

const showShopOnMap = async () => {
    if (!selectedShop.value) return;

    // 1. переключаемся на карту
    activeTab.value = 'map';

    await nextTick();

    // 2. плавный скролл к фильтрам
    const filterBlock = document.querySelector('.shops__block_filter');
    if (filterBlock) {
        const offset = 24;
        const y = filterBlock.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
            top: y,
            behavior: 'smooth',
        });
    }

    // 3. двигаем карту к магазину
    const comp = mapRef.value;
    if (!comp || !comp.ready) {
        pendingSelectedShop.value = selectedShop.value;
        return;
    }

    const gmap = comp.map ?? null;
    if (!gmap) return;

    try {
        gmap.panTo(selectedShop.value.coordinates);
        gmap.setZoom(15);
    } catch (e) {
        console.warn('showShopOnMap pan/zoom error:', e);
    }
};

const closeFullInfo = async () => {
    selectedShopId.value = null;
    scheduleOpen.value = false;

    hideBackdrop();

    const comp = mapRef.value;
    if (comp && comp.ready) {
        const gmap = comp.map ?? null;
        if (gmap) {
            try {
                // берём все магазины только из выбранного города
                const cityShops = selectedCityId.value
                    ? shops.filter(s => s.city.id === selectedCityId.value)
                    : [];

                if (cityShops.length) {
                    const bounds = new google.maps.LatLngBounds();
                    cityShops.forEach(s => bounds.extend(s.coordinates));
                    gmap.fitBounds(bounds);

                    // если мало точек, ограничиваем зум
                    if (cityShops.length <= 2) {
                        setTimeout(() => {
                            const currentZoom = gmap.getZoom();
                            const maxZoom = 14;
                            if (currentZoom > maxZoom) gmap.setZoom(maxZoom);
                        }, 100);
                    }
                } else {
                    // если город не выбран или нет точек — центр по умолчанию
                    gmap.setCenter(center);
                    gmap.setZoom(8);
                }
            } catch (e) {
                console.warn("fitBounds in closeFullInfo failed:", e);
            }
        }
    }
};

const toggleSchedule = (e) => {
    scheduleOpen.value = !scheduleOpen.value;
};

/* apply pending and fitBounds when map component becomes ready */
watch(selectedShopId, (newId, oldId) => {
    if (oldId && markerInstances.has(oldId)) {
        const marker = markerInstances.get(oldId);
        marker.content = createMarkerElement(oldId, false);
    }

    if (newId && markerInstances.has(newId)) {
        const marker = markerInstances.get(newId);
        marker.content = createMarkerElement(newId, true);
    }
});

</script>

<style scoped>

</style>
